// routes
import { ADMIN_PATH_DASHBOARD, PATH_DASHBOARD } from '../../../routes/paths';
// components
import { REACT_APP_GUIDELINE_URL } from '../../../config';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
  profile: getIcon('ic_user'),
};

export const registerNavConfig = [
  {
    items: [
      { title: 'Register', path: "/register", icon: ICONS.analytics },
    ],
  },
]

// ADMIN NAVBAR
export const adminNavConfig = [
  {
    items: [
      { title: 'Create Job Type', path: ADMIN_PATH_DASHBOARD.general.createJobType, icon: ICONS.menuItem },
      { title: 'Job Type List', path: ADMIN_PATH_DASHBOARD.general.jobTypeList, icon: ICONS.menuItem },
      { title: 'Create Question', path: ADMIN_PATH_DASHBOARD.general.createQuestion, icon: ICONS.menuItem,
        children: [
          { title: 'Basic Translation Question', path: ADMIN_PATH_DASHBOARD.general.createQuestionBasicTranslation, icon: ICONS.menuItem },
          { title: 'Multichoice Translation Question', path: ADMIN_PATH_DASHBOARD.general.createQuestionMultichoiceTranslation, icon: ICONS.menuItem },
          { title: 'Multichoice Annotation Question', path: ADMIN_PATH_DASHBOARD.general.createQuestionMultichoiceAnnotation, icon: ICONS.menuItem },
          { title: 'Yes-No Question', path: ADMIN_PATH_DASHBOARD.general.createQuestionYesNo, icon: ICONS.menuItem },
          { title: 'Transcription Question', path: ADMIN_PATH_DASHBOARD.general.createTranscriptionQuestion, icon: ICONS.menuItem },
          { title: 'VC Validator Question', path: ADMIN_PATH_DASHBOARD.general.createVCValidatorQuestion, icon: ICONS.menuItem },
          { title: 'Language Skills Question', path: ADMIN_PATH_DASHBOARD.general.createVCValidatorQuestion, icon: ICONS.menuItem,
            children: [
                {title: 'Paragraph Question', path: ADMIN_PATH_DASHBOARD.general.createLanguageParagraphQuestion, icon: ICONS.menuItem},
                {title: 'Improvement Question', path: ADMIN_PATH_DASHBOARD.general.createLanguageImprovementQuestion, icon: ICONS.menuItem},
                {title: 'Summary Question', path: ADMIN_PATH_DASHBOARD.general.createLanguageSummaryQuestion, icon: ICONS.menuItem},
                {title: 'Parallel Question', path: ADMIN_PATH_DASHBOARD.general.createLanguageParallelQuestion, icon: ICONS.menuItem},
                {title: 'Critical Thinking Question', path: ADMIN_PATH_DASHBOARD.general.createLanguageSummaryCThinking, icon: ICONS.menuItem},
                {title: 'Reading Comprehension Question', path: ADMIN_PATH_DASHBOARD.general.createLanguageReading, icon: ICONS.menuItem},
            ]},
        ],},
      { title: 'Create Test', path: ADMIN_PATH_DASHBOARD.general.createTest, icon: ICONS.menuItem,
        children: [
          { title: 'Transcription Test', path: ADMIN_PATH_DASHBOARD.general.createTranscriptionTest, icon: ICONS.menuItem },
          { title: 'Annotation Test', path: ADMIN_PATH_DASHBOARD.general.createAnnotationTest, icon: ICONS.menuItem },
          { title: 'YesNo Test', path: ADMIN_PATH_DASHBOARD.general.createYesnoTest, icon: ICONS.menuItem },
          { title: 'Translation Test', path: ADMIN_PATH_DASHBOARD.general.createTranslationTest, icon: ICONS.menuItem },
          { title: 'Language Skills Test', path: ADMIN_PATH_DASHBOARD.general.createLanguageTest, icon: ICONS.menuItem },
          { title: 'Voice Collection Validator Test', path: ADMIN_PATH_DASHBOARD.general.createVoiceCollectionValidatorTest, icon: ICONS.menuItem },
        ],
      },
      { title: 'Voice Collection', path: ADMIN_PATH_DASHBOARD.general.createVoiceCollection, icon: ICONS.menuItem,
        children: [
          { title: 'Create Voice Collection Task', path: ADMIN_PATH_DASHBOARD.general.createVoiceCollectionTask, icon: ICONS.menuItem },
          { title: 'Create Voice Collection Form', path: ADMIN_PATH_DASHBOARD.general.createVoiceCollectionForm, icon: ICONS.menuItem },
          { title: 'Browse Voice Collection Form', path: ADMIN_PATH_DASHBOARD.general.browseVoiceCollectionForms, icon: ICONS.menuItem },
          { title: 'Browse Voice Collection Form Evaluations', path: ADMIN_PATH_DASHBOARD.general.browseVoiceCollectionFormEvaluations, icon: ICONS.menuItem },
          { title: 'Browse Voice Collection Tasks', path: ADMIN_PATH_DASHBOARD.general.browseVoiceCollectionTasks, icon: ICONS.menuItem },
          { title: 'Voice Collection Evaluation Results', path: ADMIN_PATH_DASHBOARD.general.voiceCollectionEvaluationResults, icon: ICONS.menuItem },
        ],
      },
      { title: 'Upload Questions', path: ADMIN_PATH_DASHBOARD.general.uploadExcel, icon: ICONS.menuItem },
      // { title: 'My Tests', path: ADMIN_PATH_DASHBOARD.general.myTests, icon: ICONS.analytics },
      { title: 'Browse Tests', path: ADMIN_PATH_DASHBOARD.general.browseTests, icon: ICONS.menuItem },
      { title: 'Evaluate Language Skills Tests', path: ADMIN_PATH_DASHBOARD.general.browseCreativitySkillsTest, icon: ICONS.menuItem },
      { title: "User's Test Results", path: ADMIN_PATH_DASHBOARD.general.listLanguageSkillsResults, icon: ICONS.menuItem },
      { title: 'Browse Questions', path: ADMIN_PATH_DASHBOARD.general.browseQuestions, icon: ICONS.menuItem },
      // { title: 'Voice Collection Evaluation', path: ADMIN_PATH_DASHBOARD.general.voiceCollectionEvaluation, icon: ICONS.menuItem },

      { title: 'Profile', path: ADMIN_PATH_DASHBOARD.general.account, icon: ICONS.profile },
      { title: 'Admin Settings', path: ADMIN_PATH_DASHBOARD.general.createAdminSettings, icon: ICONS.menuItem },
      { title: 'Block Users', path: ADMIN_PATH_DASHBOARD.general.blockUserList, icon: ICONS.menuItem },
      { title: 'User List', path: ADMIN_PATH_DASHBOARD.general.userList, icon: ICONS.menuItem },
      { title: 'Auth Settings', path: ADMIN_PATH_DASHBOARD.general.authSettings, icon: ICONS.menuItem },
      { title: 'Add Remove Domains', path: ADMIN_PATH_DASHBOARD.general.addRemoveDomains, icon: ICONS.menuItem },
    ],
  },
];

export const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    items: [
      { title: 'Tests To Do', path: PATH_DASHBOARD.general.testToDo, icon: ICONS.calendar },
      { title: 'My Test Results', path: PATH_DASHBOARD.general.myTestResults, icon: ICONS.analytics },
      { title: 'Browse Tests', path: PATH_DASHBOARD.general.browseTest, icon: ICONS.menuItem },
      { title: 'Job List', path: PATH_DASHBOARD.general.jobList, icon: ICONS.menuItem },
      { title: 'My Qualifications', path: PATH_DASHBOARD.general.myQualifications, icon: ICONS.booking },
      { title: 'Profile', path: PATH_DASHBOARD.user.account, icon: ICONS.profile },
      { title: 'Terms of Service & Legal', path: PATH_DASHBOARD.general.termsLegal, icon: ICONS.banking },
      { title: 'Download Guideline', path: REACT_APP_GUIDELINE_URL, icon: ICONS.menuItem },
      // { title: 'Browse Voice Collection Forms', path: PATH_DASHBOARD.general.browseVoiceCollectionFormEvaluations, icon: ICONS.menuItem }, // TODO DISABLED FOR PROD
      { title: 'Evaluate Language Skills Tests', path: PATH_DASHBOARD.general.browseCreativitySkillsTest, icon: ICONS.menuItem },
    ],
  },
];
